import { usePageLayout } from '../../hooks/usePageLayout';
import { useUserSession } from '../../hooks/useUserSession';

export const useCustomerKey = (): { customerKey: string | undefined } => {
    const { userData: userDataPageLayout } = usePageLayout();
    const { userData: userDataSession } = useUserSession();

    const customerKeyUserPageLayout = userDataPageLayout?.profile?.customerKey;
    const customerKeyUserSession = userDataSession?.profile?.customerKey;
    const customerKey = customerKeyUserPageLayout || customerKeyUserSession;

    return { customerKey: customerKey ? String(customerKey) : undefined };
};
